import { TcListFilterModel, TcListSortModel } from '@tc/core';
import { EntitiesEnum } from '@match-fix/shared';
import { createAction, props } from '@ngrx/store';

export const filterListItems = createAction(
  '[List] Filter list items',
  props<{ entityName: EntitiesEnum, filter: TcListFilterModel, order?: TcListSortModel, initial?: boolean }>());
